"use strict";
/**
 * Shared enrichment output types — the single source of truth for the per-scope payloads that
 * enrichers produce and that downstream consumers (search builder, Data API) read. Defined once
 * here so the producer (enrich) and consumers (search) reference the same contract.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./agent-source-listing"), exports);
__exportStar(require("./amenities"), exports);
__exportStar(require("./asking-price-history"), exports);
__exportStar(require("./enrichment-run"), exports);
__exportStar(require("./epc"), exports);
__exportStar(require("./feature-extraction"), exports);
__exportStar(require("./floor-plan"), exports);
__exportStar(require("./image-descriptions"), exports);
__exportStar(require("./image-embeddings"), exports);
__exportStar(require("./location-intelligence"), exports);
__exportStar(require("./pacing"), exports);
__exportStar(require("./property-identity"), exports);
__exportStar(require("./recurring-charges"), exports);
__exportStar(require("./test-enricher"), exports);
__exportStar(require("./transport"), exports);
//# sourceMappingURL=index.js.map